import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useContext, useMemo, } from 'react';
import { customColorSwatchImage } from '../SwatchPicker/customColorSwatchImage';
import { SwatchPickerContext } from '../SwatchPicker/SwatchPickerContext';
import { SwatchPickerDesign } from '../SwatchPicker/SwatchPickerDesign';
import { useSwatchStyles } from '../SwatchPicker/useSwatchStyles';
const customColorImageUrl = `'data:image/svg+xml;utf8,${encodeURIComponent(customColorSwatchImage)}'`;
const swatchContainerStyles = css `
  position: relative;
`;
const defaultProps = {
    displayName: '',
};
const CustomColorSwatch = ({ displayName = defaultProps.displayName, onClick, }) => {
    const { shape, size, } = useContext(SwatchPickerContext);
    const swatchStyles = useSwatchStyles({
        isDisabled: false,
        isSelected: false,
        shape,
        size,
    });
    const customColorStyles = useMemo(() => (css `
        ${swatchStyles}
        background-color: transparent;

        &:focus {
          outline: none;
        }
      `), [
        swatchStyles,
    ]);
    return (_jsx("div", Object.assign({ css: swatchContainerStyles }, { children: _jsx("button", Object.assign({ "aria-label": displayName, css: customColorStyles, "data-test-ref": "swatch-custom-color-button", onClick: onClick, title: displayName, type: "button" }, { children: _jsx(SwatchPickerDesign, { imageUrl: customColorImageUrl }) })) })));
};
const MemoizedCustomColorSwatch = memo(CustomColorSwatch);
export { MemoizedCustomColorSwatch as CustomColorSwatch };
